<!-- src/components/Toast.vue -->
<template>
  <transition name="fade">
    <div v-if="visible" class="toast">
      {{ message }}
    </div>
  </transition>
</template>

<script>
import ToastBus from "@/utils/ToastBus";

export default {
  name: "Toast",
  data() {
    return {
      visible: false,
      message: "",
      timeoutId: null,
    };
  },
  created() {
    ToastBus.$on("show", this.show);
  },
  beforeDestroy() {
    ToastBus.$off("show", this.show);
  },
  methods: {
    show(msg, duration = 2000) {
      this.message = msg;
      this.visible = true;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.visible = false;
      }, duration);
    },
  },
};
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 24px;
  right: 24px;
  background: #111;
  color: #fff;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  z-index: 9999;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
